import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import BackButton from '../components/BackButton'
import HeaderDashboardByVehicle from '../components/HeaderDashboardByVehicle'
import HorizontalEventMenuByVehicle from '../components/HorizontalEventMenuByVehicle'
import Time from '../components/Time'
import EventContentByVehicle from '../components/EventContentByVehicle'
import backIcon from '../images/backIcon.svg'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import { REFUEL_EVENT } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'

class EventByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.pollingInterval = null
    this.state = {
      tokenIsValide: false,
      refuelEvents: [],
      trackableLabel: props.location.state && props.location.state.trackableLabel ? props.location.state.trackableLabel : localStorage.getItem('trackableLabel'),
      trackableName: props.location.state && props.location.state.trackableName ? props.location.state.trackableName : localStorage.getItem('trackableName'),
      loadingTrb: true
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          self.setState({
            tokenIsValide: true
          }, () => {
            // Fetch data immediately after state is set
            self.fetchData()

            // Set up polling every 1 minute (60000ms)
            self.pollingInterval = setInterval(() => {
              self.fetchData()
            }, 60000)
          })
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  fetchData () {
    this.refuelEvents(this.state.trackableLabel)
      .then((refuelEvents) => {
        if (this._isMounted) {
          this.setState({
            refuelEvents,
            loadingTrb: false
          })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  refuelEvents (trackableLabel) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT,
          variables: { trackable_labels: [trackableLabel] },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  componentWillUnmount () {
    this._isMounted = false
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  backToList () {
    console.log("BACK TO LIST")
  }

  render () {
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu />
              </td>
              <td style={styles.content}>
                <BackButton
                  link='all-report'
                  label='LISTE'
                  img={backIcon}
                  onClick={() => this.backToList()}
                />
                <HeaderDashboardByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='event'
                />
                <HorizontalEventMenuByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='all'
                />
                {this.state.loadingTrb ? <CircularProgress
                  style={{ color: '#7ED321', marginTop: '50px' }}
                  color='inherit'
                /> : <EventContentByVehicle
                  route='EventByVehicle'
                  events={this.state.refuelEvents}
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  trackableLabel={this.state.trackableLabel}
                  trackableName={this.state.trackableName}
                />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  }
}

export default EventByVehicleComponent
